import {TableauEmbedContentActions, TableauEmbedContentActionsTypes} from './actions';

export const initialTableauEmbedContentState: TableauEmbedContentState = {
  init: false,
  form: {
    filters: '',
    integration_id: '',
    view_id: '',
    view_name: '',
    workbook_id: '',
    workbook_name: '',
    embed_url: '',
  },
}

export interface TableauEmbedContentState {
  init: boolean;
  form: any;
}

export default function tableauEmbedContentReducer(
  state: TableauEmbedContentState = initialTableauEmbedContentState,
  action: TableauEmbedContentActions
): TableauEmbedContentState {

  switch (action.type) {
    case TableauEmbedContentActionsTypes.SET_INIT:
      return {
        ...state,
        init: action.payload,
      }
    case TableauEmbedContentActionsTypes.SET_TABLEAU_EMBED_CONTENT_FORM:
      return {
        ...state,
        form: action.payload,
        init: true,
      }
    case TableauEmbedContentActionsTypes.SET_TABLEAU_EMBED_CONTENT_FORM_KEY_VALUE:
      return {
        ...state,
        form: {
          ...state.form || {},
          [action.payload.key]: action.payload.value,
        },
      }
    case TableauEmbedContentActionsTypes.SET_TABLEAU_EMBED_CONTENT_FORM_KEYS_VALUES:
      return {
        ...state,
        form: {
          ...state.form || {},
          ...action.payload,
        }
      }
    default:
      return state;
  }
};

// Functions
